let config;

if (process.env.NODE_ENV === "production"){
    config = {
        loginUrl : "https://intern.schuberth.info",
        cookieDomain: "intern.schuberth.info",
        APIURL: "https://prod.api.schuberth.info"
    }
}
else {
    config = {
        loginUrl : "http://localhost:8080",
        cookieDomain: "localhost",
        APIURL: "http://dev.api.schuberth.local"
    }
}


export { config }